import React from "react";
import Card from "./Card";
import Pagination from "./Pagination";

interface TableProps {
  header: React.ReactNode;
  className?: string | null;
  body: React.ReactNode;
  showPagination?: boolean;
  paginationHasPrevious: boolean;
  paginationHasNext: boolean;
  paginationCurrentPage: number;
  paginationTotalPages: number;
  paginationTotalObjects: number;
  paginationQueryParams: string[];
}

export default function Table({
  header,
  className,
  body,
  showPagination,
  paginationHasPrevious,
  paginationHasNext,
  paginationCurrentPage,
  paginationTotalPages,
  paginationTotalObjects,
  paginationQueryParams,
}: TableProps) {
  return (
    <>
      <div className={className === null ? "" : className}>
        <Card>
          <table className="table-auto w-full text-center text-sm overflow-x-auto">
            <thead className="text-base border-b border-light/50">
              {header}
            </thead>
            <tbody>{body}</tbody>
          </table>
        </Card>
      </div>

      {/* Pagination */}
      {showPagination && (
        <Pagination
          className="mt-10"
          showPrevious={paginationHasPrevious}
          showNext={paginationHasNext}
          currentPage={paginationCurrentPage}
          totalPages={paginationTotalPages}
          totalObjects={paginationTotalObjects}
          queryParams={paginationQueryParams}
        />
      )}
    </>
  );
}

Table.defaultProps = {
  className: "mx-1",
  showPagination: true,
};
